import { render, staticRenderFns } from "./profile_edit.vue?vue&type=template&id=127f0497&scoped=true&"
import script from "./profile_edit.vue?vue&type=script&lang=js&"
export * from "./profile_edit.vue?vue&type=script&lang=js&"
import style0 from "./profile_edit.vue?vue&type=style&index=0&id=127f0497&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127f0497",
  null
  
)

export default component.exports